import ApiResourceManager from '../ApiResourceManager';

export default class ProviderBillingPriceBookManager extends ApiResourceManager {
  /**
   * Both endpoints act on the on-behalf-of service provider. Passing an
   * explicit id overrides the header derived from the sidebar selection, so
   * the Partners page can edit any partner's price book without re-scoping
   * the dashboard. On-behalf of the master, PUT edits the default list.
   */
  get = (serviceProviderId = undefined) =>
    this.request({
      method: 'GET',
      url: '/provider-license-products',
      ...(serviceProviderId && { headers: { 'x-on-behalf-of-service-provider': serviceProviderId } }),
    });

  /**
   * @param prices [{ product_id, amount }] — amount in minor units (cents), null removes the row.
   */
  update = (prices, serviceProviderId = undefined) =>
    this.request({
      method: 'PUT',
      url: '/provider-license-products',
      data: { prices },
      ...(serviceProviderId && { headers: { 'x-on-behalf-of-service-provider': serviceProviderId } }),
    });
}
